<script setup lang="ts">
import axios from 'axios';
import { onMounted, reactive, ref, toRaw } from 'vue';
import { useRouter } from 'vue-router';
import MarketCardProduct from './components/MarketCardProduct.vue';

const router = useRouter();
const layout = ref('none');
const loading = ref(false);
const errorMessage = ref('');
const startupInfos = reactive({
    categories: [] as any[],
});

const itemsList = ref([] as any[]);
const queryParams = reactive({
    pageNumber: 1,
    sorting: null as string | null,
    search: '',
    market_categorie_id: null as number | null,
});
const pagination = reactive({
    total: 0,
    per_page: 16,
    last_page: 1
});
const SORT_OPTIONS = [
    { value: 'nom_asc', label: 'Nom (ASC)', sort_column: 'nom', sort_direction: 'ASC' },
    { value: 'nom_desc', label: 'Nom (DESC)', sort_column: 'nom', sort_direction: 'DESC' },
    { value: 'created_at_asc', label: 'Date (ASC)', sort_column: 'created_at', sort_direction: 'ASC' },
    { value: 'created_at_desc', label: 'Date (DESC)', sort_column: 'created_at', sort_direction: 'DESC' },
];

onMounted(() => {
  layout.value = router.currentRoute.value.meta.layout as string || 'none';
  doGetStartupInfos().then(() => {
      doGetProducts();
  });
});

async function doGetStartupInfos() {
    try {
        loading.value = true;
        errorMessage.value = '';
        const httpResponse = await axios.get(`/market/products_startup_infos`);
        Object.assign(startupInfos, httpResponse.data);
    } catch(error: any) {
        errorMessage.value = error.message;
    } finally {
        loading.value = false;
    }
}

async function doGetProducts() {
    try {
        loading.value = true;
        errorMessage.value = '';
        const queryParamsRaw = toRaw(queryParams);
        const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
        const httpResponse = await axios.get(`/market/products?${queryString}`);
        itemsList.value = httpResponse.data.data;
        pagination.total = httpResponse.data.total;
        pagination.per_page = httpResponse.data.per_page;
        pagination.last_page = httpResponse.data.last_page;
    } catch(error: any) {
        errorMessage.value = error.message;
    } finally {
        loading.value = false;
    }
}

function onFiltersChanged() {
    const sortItem = SORT_OPTIONS.find(o => o.value == queryParams.sorting);
    if (sortItem) {
        queryParams.pageNumber = 1;
    }
    doGetProducts();
}

function onPaginate(pageNumber: number) {
    queryParams.pageNumber = pageNumber;
    doGetProducts();
}
</script>
<template>
  <main class="main-market">

        <div class="page-space-50" v-if="layout == 'none'"></div>
        <section class="container-small">
            
            <div class="flex-mobile justify-content-space-between align-items-center">
                <div class="s5_mobile">
                    <select class="form-select-ghost w-100 secondary-font font-semibold" name="market_categorie_id" id="market_categorie_id" v-model="queryParams.market_categorie_id" @change="onFiltersChanged"> 
                        <option :value="null" selected>Toutes les catégories</option>
                        <option v-for="(categorie, index) in startupInfos.categories" :key="index" :value="index">{{ categorie.nom }}</option>
                    </select>
                </div>
                <div class="s10_mobile container-full-2">
                    <!--Search in view Component-->
                    <div class="search-view-input-set">
                        <input type="text" class="search-view-input" placeholder="Recherche..." v-model="queryParams.search" @keyup.enter="onFiltersChanged" />
                        <!-- loading sm tips color2 light white white2 success info warning danger-->
                        <!-- <button class="btn-ultra white tips">
                            <div class="btn-show">
                                <img src="/public/icons/icon-go.svg" class="btn-icon" alt="" />
                            </div>
                            <div class="btn-loading">
                                <div class="loader-dots"></div>
                            </div>
                        </button> -->
                    </div>
                    <!--End Search in view Component-->
                </div>
                <div class="s5_mobile">
                    <select class="form-select-ghost sm w-100 secondary-font font-semibold" v-model="queryParams.sorting" name="filter-sort" id="filter-sort" @change="onFiltersChanged"> 
                        <option :value="null">Trier par</option>
                        <option v-for="(option, index) in SORT_OPTIONS" :key="index" :value="option.value">{{ option.label }}</option>
                    </select>
                </div>
            </div>
            <div class="clear-both h-30"></div>

            <div style="height: 300px; display: flex; justify-content: center; align-items: center;" v-if="loading">
                <div class="loader dark"></div>
            </div>
            <div class="grid-web4" v-if="!loading && itemsList.length > 0">
                <market-card-product v-for="(item, index) in itemsList" :key="index" :produit="item" :layout="layout" />
            </div>
            <div style="height: 300px; display: flex; justify-content: center; align-items: center;" v-if="!loading && itemsList.length == 0">
                <div class="text-center mt-40 mb-40">
                    <h3 class="secondary-font font-semibold">Aucun produit disponible</h3>
                </div>
            </div>

            <div class="clear-both h-30"></div>
            <!--Pagination-->
            <div style="display: flex; flex-direction: row; justify-content: center;">
                <custom-pagination v-model="queryParams.pageNumber" :total="pagination.total" :per-page="pagination.per_page" :last_page="pagination.last_page" @update:modelValue="onPaginate" />
            </div>
            <!---->

        </section>

        <div class="clear-both h-60"></div>
  </main>
</template>

